import { ChildProps } from '@apollo/client/react/hoc';
// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';

import React from 'react';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { ListingsCollection } from '@reverbdotcom/commons/src/components/listings_collection';
import {
  CoreListingItem2ProductModuleListingRow,
  reverb_search_ListingsSearchRequest_Sort,
} from '@reverbdotcom/commons/src/gql/graphql';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { MINT, B_STOCK } from '@reverbdotcom/commons/src/condition_helpers';

interface IExternalProps {
  canonicalProductId?: string;
  listingCondition: string;
  minCount?: number;
}

export type IProps = ChildProps<
  IExternalProps,
  CoreListingItem2ProductModuleListingRow.Query,
  CoreListingItem2ProductModuleListingRow.Variables
>;

export function Item2ProductModuleListingRow({ canonicalProductId, listingCondition, minCount = 0, data }: IProps) {
  const listings = data?.listingsSearch?.listings || [];
  const validProduct = !!canonicalProductId && listings.length > minCount;

  const mParticleViewData = {
    componentName: 'ProductModuleListingRow',
    eventName: MParticleEventName.ComponentView,
    listingCondition: listingCondition,
  };

  useViewTracking(mParticleViewData, validProduct);

  if (!validProduct) return null;

  return (
    <div className="item2-product-module__b-stock-listings">
      <ListingsCollection
        listings={listings}
        hideListingCardTitle={true}
        minimalNudges={true}
      />
    </div>
  );
}

const withSearch = withGraphql<
  IExternalProps,
  CoreListingItem2ProductModuleListingRow.Query,
  CoreListingItem2ProductModuleListingRow.Variables
>(
  gql`
    query Core_Listing_Item2ProductModuleListingRow(
      $canonicalProductIds: [String]
      $conditionSlugs: [String]
      $sort: reverb_search_ListingsSearchRequest_Sort
    ) {
      listingsSearch(
        input: {
          canonicalProductIds: $canonicalProductIds
          conditionSlugs: $conditionSlugs
          bumpCount: 0
          sort: $sort
        }
      ) {
          listings {
            _id
            ...ListingsCollection
            }
      }
    }
    ${ListingsCollection.fragments.listing}
  `,
  {
    options: ({ canonicalProductId }) => ({
      variables: {
        canonicalProductIds: [canonicalProductId],
        conditionSlugs: [MINT, B_STOCK],
        sort: reverb_search_ListingsSearchRequest_Sort.NONE,
      },
    }),
  },
);

export default withSearch(Item2ProductModuleListingRow);
